import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  width: 40,
  height: 40,
  viewboxWidth: 40,
  viewboxHeight: 40,
};

const PlusCircleIcon = ({
  width = defaults.width,
  height = defaults.height,
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}) => {
  return (
    <SVGLoader
      width={width}
      height={height}
      viewboxWidth={viewboxWidth}
      viewboxHeight={viewboxHeight}
      {...rest}
    >
      <path
        d="M19.9997 0.745117C16.1279 0.745117 12.3431 1.89322 9.12391 4.04424C5.90469 6.19525 3.3956 9.25258 1.91396 12.8296C0.43231 16.4066 0.0446436 20.3426 0.799981 24.14C1.55532 27.9373 3.41973 31.4254 6.15746 34.1631C8.89519 36.9008 12.3833 38.7653 16.1806 39.5206C19.9779 40.2759 23.914 39.8883 27.491 38.4066C31.068 36.925 34.1253 34.4159 36.2763 31.1967C38.4274 27.9774 39.5755 24.1927 39.5755 20.3209C39.5675 15.1315 37.5025 10.157 33.833 6.48754C30.1636 2.81808 25.189 0.753082 19.9997 0.745117ZM10.2117 20.3209C10.2195 19.7243 10.46 19.1543 10.8819 18.7324C11.3039 18.3105 11.8739 18.07 12.4705 18.0622H16.988C17.1877 18.0622 17.3792 17.9829 17.5204 17.8417C17.6616 17.7005 17.7409 17.509 17.7409 17.3093V12.7918C17.7409 12.1927 17.9789 11.6182 18.4025 11.1946C18.8261 10.771 19.4006 10.533 19.9997 10.533C20.5987 10.533 21.1732 10.771 21.5968 11.1946C22.0204 11.6182 22.2584 12.1927 22.2584 12.7918V17.3093C22.2584 17.509 22.3377 17.7005 22.4789 17.8417C22.6201 17.9829 22.8116 18.0622 23.0113 18.0622H27.5288C28.1279 18.0622 28.7024 18.3002 29.126 18.7238C29.5496 19.1474 29.7876 19.7219 29.7876 20.3209C29.7876 20.92 29.5496 21.4945 29.126 21.9181C28.7024 22.3417 28.1279 22.5797 27.5288 22.5797H23.0113C22.8116 22.5797 22.6201 22.659 22.4789 22.8002C22.3377 22.9414 22.2584 23.1329 22.2584 23.3326V27.8501C22.2584 28.4491 22.0204 29.0237 21.5968 29.4473C21.1732 29.8709 20.5987 30.1088 19.9997 30.1088C19.4006 30.1088 18.8261 29.8709 18.4025 29.4473C17.9789 29.0237 17.7409 28.4491 17.7409 27.8501V23.3326C17.7409 23.1329 17.6616 22.9414 17.5204 22.8002C17.3792 22.659 17.1877 22.5797 16.988 22.5797H12.4705C11.8739 22.5719 11.3039 22.3314 10.8819 21.9095C10.46 21.4876 10.2195 20.9176 10.2117 20.3209Z"
        fill="currentColor"
      />
    </SVGLoader>
  );
};

export default PlusCircleIcon;
